import { motion } from "framer-motion";
import { Card } from "../../../components/ui/Card";

const stats = [
  {
    value: "98%",
    label: "Code Quality Improvement",
    description: "Across all reviewed PRs",
    gradient: "from-purple-400 via-pink-400 to-blue-400",
  },
  {
    value: "2.8x",
    label: "Development Velocity",
    description: "Faster time to production",
    gradient: "from-blue-400 via-purple-400 to-pink-400",
  },
  {
    value: "92%",
    label: "Issue Prevention",
    description: "Before production deployment",
    gradient: "from-pink-400 via-blue-400 to-purple-400",
  },
];

export function Stats() {
  return (
    <section className="relative py-32">
      {/* Aurora Effect */}
      <div className="absolute inset-0 overflow-hidden opacity-40">
        <div className="absolute top-0 right-0 w-96 h-96 bg-purple-500/30 rounded-full mix-blend-multiply filter blur-[128px] animate-aurora" />
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-blue-500/30 rounded-full mix-blend-multiply filter blur-[128px] animate-aurora delay-[2s]" />
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="aurora-gradient">
            Measurable Impact
          </h2>
          <p className="mt-4 text-lg text-white/60">
            Real results from teams using our AI-powered code reviews
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {stats.map((stat, index) => (
            <motion.div
              key={stat.label}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.2 }}
            >
              <Card
                variant="hover"
                className="p-8 text-center backdrop-blur-3xl bg-white/[0.02] border-white/10 hover:bg-white/[0.04] transition-all duration-300"
              >
                <div
                  className={`text-5xl font-bold bg-gradient-to-r ${stat.gradient} text-transparent bg-clip-text mb-3`}
                >
                  {stat.value}
                </div>
                <div className="text-lg font-medium text-white/90 mb-2">{stat.label}</div>
                <div className="text-sm text-white/60">{stat.description}</div>
              </Card>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
} 